import React, { useMemo } from 'react';

import {
	useClassNames,
} from '@common';

type theme = 'primary' | 'default';
type tag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'h7';
interface TitleProps extends React.HTMLAttributes<HTMLHeadingElement>{
	tag?: tag,
	theme?: theme,
	centered?: boolean,
	trailing?: JSX.Element,
}

import './title.scss';

function Title(props: TitleProps): JSX.Element {
	const {
		theme = 'default',
		centered = false,
		tag = 'h1',
		className,
		trailing,
		children,
		...otherProps
	} = props;

	const classes = useClassNames(
		'title',
		className,
		centered && 'centered',
		theme,
	);

	const trailingView = useMemo((): JSX.Element => {
		return trailing && (
			<div className="title__trailing">
				{trailing}
			</div>
		);
	}, [trailing]);

	return React.createElement(
		tag,
		{
			className: classes,
			...otherProps,
		},
		<>
			<div className="title__main">
				{children}
			</div>
			{trailingView}
		</>
	);
}

export {Title};